<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <button class="close-btn" @click="$emit('close')">&times;</button>

      <div class="tabs">
        <button :class="{ active: isLogin }" @click="isLogin = true">{{ $t('login') }}</button>
        <button :class="{ active: !isLogin }" @click="isLogin = false">{{ $t('register') }}</button>
      </div>

      <!-- Login Form -->
      <form v-if="isLogin" @submit.prevent="handleLogin" class="auth-form">
        <div class="form-group">
          <input type="tel" v-model="loginForm.phone" :placeholder="$t('phone')" required />
        </div>
        <div class="form-group">
          <input type="password" v-model="loginForm.password" :placeholder="$t('password')" required />
        </div>
        <button type="submit" class="submit-btn" :disabled="loading">
          {{ loading ? $t('loading') : $t('login') }}
        </button>
        <p v-if="error" class="error-msg">{{ error }}</p>
      </form>

      <!-- Register Form -->
      <form v-else @submit.prevent="handleRegister" class="auth-form">
        <div class="form-group">
          <input type="text" v-model="registerForm.name" :placeholder="$t('name')" required />
        </div>
        <div class="form-group">
          <input type="tel" v-model="registerForm.phone" :placeholder="$t('phone')" required />
        </div>
        <div class="form-group">
          <input type="password" v-model="registerForm.password" :placeholder="$t('password')" required />
        </div>
        <button type="submit" class="submit-btn" :disabled="loading">
          {{ loading ? $t('loading') : $t('register') }}
        </button>
        <p v-if="error" class="error-msg">{{ error }}</p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { fetchApi } from '../../utils/api'
import { API_BASE_URL } from '../../config'
import store from '../../store'

const emit = defineEmits(['close'])
const isLogin = ref(true)
const loading = ref(false)
const error = ref('')

const loginForm = reactive({ phone: '', password: '' })
const registerForm = reactive({ name: '', phone: '', password: '' })

async function handleLogin() {
  loading.value = true
  error.value = ''
  try {
    const res = await fetchApi(`${API_BASE_URL}?token=test&action=customerLogin`, {
      method: 'POST',
      body: JSON.stringify({
        action: 'login',
        phone: loginForm.phone,
        password: loginForm.password
      })
    })
    const data = await res.json()
    if (data.success) {
      store.login(data.token, data.user)
      emit('close')
    } else {
      error.value = data.message || 'Login failed'
    }
  } catch (e) {
    error.value = 'Network error'
  } finally {
    loading.value = false
  }
}

async function handleRegister() {
  loading.value = true
  error.value = ''
  try {
    const res = await fetchApi(`${API_BASE_URL}?token=test&action=customerLogin`, {
      method: 'POST',
      body: JSON.stringify({
        action: 'register',
        name: registerForm.name,
        phone: registerForm.phone,
        password: registerForm.password
      })
    })
    const data = await res.json()
    if (data.success) {
      store.login(data.token, data.user)
      emit('close')
    } else {
      error.value = data.message || 'Registration failed'
    }
  } catch (e) {
    error.value = 'Network error'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #64748b;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #f1f5f9;
}

.tabs {
  display: flex;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
}

.tabs button {
  flex: 1;
  padding: 12px;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
  color: #94a3b8;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
  font-size: 1rem;
}

.tabs button.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}

.form-group {
  margin-bottom: 16px;
}

.form-group input {
  width: 100%;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  outline: none;
  box-sizing: border-box;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.form-group input:focus {
  border-color: #3b82f6;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
}

.submit-btn:hover {
  background: #2563eb;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-msg {
  color: #ef4444;
  margin-top: 12px;
  font-size: 0.9rem;
  text-align: center;
}
</style>
